// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Search24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Search24Circle: FC<Search24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm1.3-14.3 6.3 6.3 1.4-1.4-6.3-6.3a6.096 6.096 0 0 0 1.3-3.8c0-1.817-.63-3.354-1.887-4.612C16.854 6.629 15.317 6 13.5 6c-1.817 0-3.354.63-4.613 1.888C7.63 9.146 7 10.683 7 12.5c0 1.817.63 3.354 1.887 4.613C10.146 18.37 11.683 19 13.5 19a6.096 6.096 0 0 0 3.8-1.3Zm-.613-2.012C15.813 16.561 14.75 17 13.5 17c-1.25 0-2.313-.438-3.188-1.313C9.438 14.813 9 13.75 9 12.5c0-1.25.438-2.313 1.313-3.188C11.187 8.438 12.25 8 13.5 8c1.25 0 2.313.438 3.188 1.313C17.563 10.187 18 11.25 18 12.5c0 1.25-.438 2.313-1.313 3.188Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Search24Circle;
